const confluenceSelector = state => state.confluence;

export const confluenceTokenSelector = state => confluenceSelector(state).token;

export const confluenceAccessibleResourcesSelector = state =>
  confluenceSelector(state).accessibleResources;

export const confluenceResourceContentSelector = state =>
  confluenceSelector(state).resourceContent;
